import request from '@/utils/request';
export const defaultPolicyData = {
  id: 0,
  enabled: true,
  name: '',
  startDate: '',
  endDate: '',
  image: null
};
export const getPolicies = params => request({
  url: '/policies',
  method: 'get',
  params
});
export const getPolicyById = id => request({
  url: `/policies/${id}`,
  method: 'get'
});
export const updatePolicy = (id, data) => request({
  url: `/policies/${id}`,
  method: 'patch',
  data
});
export const deletePolicy = id => request({
  url: `/policies/${id}`,
  method: 'delete'
});
export const createPolicy = data => request({
  url: '/policies',
  method: 'post',
  data
});